import { render, staticRenderFns } from "./IndexInTable.vue?vue&type=template&id=5e171d73&"
import script from "./IndexInTable.vue?vue&type=script&lang=js&"
export * from "./IndexInTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports